import { useBranding } from '@/lib/branding';

/**
 * 채팅 입력창 아래 가운데에 표시하는 관리자 설정 안내 문구 (ChatGPT 의 "…실수를 할 수 있습니다" 류).
 * `/admin/branding` 에서 설정 + on/off. 서버가 (enabled && 비어있지 않음) 게이트를 적용하므로
 * 여기서는 빈 문자열이면 렌더하지 않는다.
 *
 * 입력창과 같은 비스크롤 하단 영역(shrink-0)에 두고 호출 — 대화가 길어져도 잘리지 않는다.
 */
export function ChatFooterNote() {
  const { chatFooterText } = useBranding();
  if (!chatFooterText) return null;
  return (
    <p className="w-full max-w-3xl mx-auto mt-2 text-center text-sm text-foreground-muted whitespace-pre-wrap break-words">
      {chatFooterText}
    </p>
  );
}
